"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.close = void 0;
/* eslint-disable no-undef */
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation_1 = require("@cck/common/dist/data/Evaluation");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firebase = __importStar(require("../firebase/fbase"));
var ControlManager = __importStar(require("../rcm/ControlManager"));
var RiskManager = __importStar(require("../rcm/RiskManager"));
var StaffManager_1 = require("../rcm/StaffManager");
var StorageManager_1 = require("../storage/StorageManager");
var BatchPromises_1 = require("../utils/BatchPromises");
var EvaluationLoader_1 = require("./EvaluationLoader");
var EvaluationUtils_1 = require("./EvaluationUtils");
var ExcelExporter_1 = require("./ExcelExporter");
var TemplateUpdater_1 = require("./TemplateUpdater");
function classifyWeakData(designDefect) {
    // 해당 control id 의 weakStateData 를 받아서 필요한 업데이트 종류에 맞게 나눈다
    // 3가지의 분류가 생긴다
    // control 자체 value => controlUpdate
    // control-staff 맵핑 => controlMappingWithStaff
    // 연결된 risk의 내용 => riskUpdate
    var result = {
        control: {},
        risk: {},
        staffId: ''
    };
    lodash_1.default.forEach(designDefect.control, function (value, key) {
        if (key === 'id' ||
            key === 'department' ||
            !(0, Evaluation_1.isDesignDefectItem)(value) ||
            lodash_1.default.isEmpty(value.content)) {
            return;
        }
        if (key === 'owner') {
            result.staffId = value.content;
        }
        else {
            result.control[key] = value.content;
        }
    });
    lodash_1.default.forEach(designDefect.risk, function (value, key) {
        if (key === 'id' || !(0, Evaluation_1.isDesignDefectItem)(value) || lodash_1.default.isEmpty(value.content)) {
            return;
        }
        result.risk[key] = value.content;
    });
    return result;
}
function updateRCM(controlId, newControl, newRisk, staffId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newControl) return [3 /*break*/, 2];
                    return [4 /*yield*/, ControlManager.update(newControl)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!newRisk) return [3 /*break*/, 4];
                    return [4 /*yield*/, RiskManager.update(newRisk)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    if (!staffId) return [3 /*break*/, 6];
                    return [4 /*yield*/, ControlManager.updateMapWithStaff(controlId, staffId)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, (0, TemplateUpdater_1.updateTemplate)(Evaluation_1.Type.Operation, controlId, undefined)];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function applyDesignEvaluationModificationToRCM(name) {
    return __awaiter(this, void 0, void 0, function () {
        var states, approvedStates, targetStateDataList, classifiedList;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationStates)(Evaluation_1.Type.Design, name)
                    // 일단 대상의 전제는 state="5"(승인완료 == 보고서관련된 것은 마무리가 된 상태) 이다.
                    // 그러므로 state="5" 인 애들만 가지고 해야한다
                ];
                case 1:
                    states = _a.sent();
                    approvedStates = lodash_1.default.pickBy(states, function (evaluationState) { return evaluationState.state === Evaluation_1.ProgressState.Approved; });
                    // 제한사항 검사
                    // resultState 가 "3"(Ineffective) 인데 weakState 가 "1" 혹은 "2" 인 것이 존재하는 경우
                    if (lodash_1.default.some(lodash_1.default.map(approvedStates, function (state) {
                        return state.resultState === Evaluation_1.ResultState.Defect &&
                            (state.weakState === Evaluation_1.DesignWeakState.Default ||
                                state.weakState === Evaluation_1.DesignWeakState.Pending);
                    }))) {
                        return [2 /*return*/, Promise.reject(new Error("\uD574\uB2F9 \uCEE8\uD2B8\uB864\uB4E4\uC5D0 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uB2E4. \uBBF8\uBE44\uC810 \uD3C9\uAC00\uAC00 \uC644\uB8CC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."))];
                    }
                    targetStateDataList = lodash_1.default.pickBy(approvedStates, function (stateData) {
                        return (
                        // stateData.resultState === ResultState.Defect &&
                        stateData.weakState === Evaluation_1.DesignWeakState.Modification);
                    });
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(targetStateDataList, function (targetStateData, controlId) { return __awaiter(_this, void 0, void 0, function () {
                            var weakStateData, classifiedData, newControl, originalControl, newRisk, originalRisk;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        weakStateData = targetStateData.weakStateData;
                                        classifiedData = classifyWeakData(weakStateData);
                                        if (!!lodash_1.default.isEmpty(classifiedData.control)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, ControlManager.get(controlId)];
                                    case 1:
                                        originalControl = _a.sent();
                                        newControl = lodash_1.default.assign(originalControl, classifiedData.control);
                                        _a.label = 2;
                                    case 2:
                                        if (!!lodash_1.default.isEmpty(classifiedData.risk)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, RiskManager.get(weakStateData.riskId)];
                                    case 3:
                                        originalRisk = _a.sent();
                                        newRisk = lodash_1.default.assign(originalRisk, classifiedData.risk);
                                        _a.label = 4;
                                    case 4: return [2 /*return*/, {
                                            controlId: controlId,
                                            newControl: newControl,
                                            newRisk: newRisk,
                                            staffId: classifiedData.staffId
                                        }];
                                }
                            });
                        }); }))];
                case 2:
                    classifiedList = _a.sent();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(classifiedList, function (classified) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, updateRCM(classified.controlId, classified.newControl, classified.newRisk, classified.staffId)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function getFileInfo(basePath, controlId, baseFile) {
    if (baseFile && !lodash_1.default.isEmpty(baseFile.name) && baseFile.state === BaseFile_1.FileState.OK) {
        return {
            controlId: controlId,
            fileFullPath: "".concat(basePath, "/").concat(controlId, "/").concat(baseFile.name),
            fileName: baseFile.name,
            fileTypeInZip: baseFile.type
        };
    }
}
function archiveEvaluation(type, name) {
    return __awaiter(this, void 0, void 0, function () {
        var fileInfos, fileBasePath, archiveBasePath, contents, staffAll, evaluationAll, blobs;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileInfos = [];
                    fileBasePath = "".concat((0, Evaluation_1.getKoEvaluation)(type), "/").concat(name);
                    archiveBasePath = "Archive/".concat((0, Evaluation_1.getKoEvaluation)(type));
                    return [4 /*yield*/, (0, EvaluationLoader_1.getContents)(type, name)];
                case 1:
                    contents = _a.sent();
                    return [4 /*yield*/, (0, StaffManager_1.getAll)()];
                case 2:
                    staffAll = _a.sent();
                    return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationItems)(type, name)];
                case 3:
                    evaluationAll = _a.sent();
                    lodash_1.default.forEach(contents, function (content, controlId) {
                        var files = content.files;
                        fileInfos.push(getFileInfo(fileBasePath, controlId, files.record));
                        if (files.population) {
                            fileInfos.push(getFileInfo(fileBasePath, controlId, files.population));
                        }
                        lodash_1.default.forEach(files.evidence, function (evidence) {
                            fileInfos.push(getFileInfo(fileBasePath, controlId, evidence));
                        });
                        lodash_1.default.forEach(files.extra, function (extra) {
                            fileInfos.push(getFileInfo(fileBasePath, controlId, extra));
                        });
                    });
                    return [4 /*yield*/, (0, BatchPromises_1.promiseAllInBatches)(function (fileInfo) { return __awaiter(_this, void 0, void 0, function () {
                            var fileBlob;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(type === Evaluation_1.Type.Operation && fileInfo.fileTypeInZip === '보고서')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, ExcelExporter_1.exportToExcel)(staffAll, evaluationAll[fileInfo.controlId])];
                                    case 1:
                                        // 운영평가-보고서 의 경우 파일의 존재유무와 관계없이 생성해서 Archive 한다.
                                        fileBlob = _a.sent();
                                        return [3 /*break*/, 4];
                                    case 2: return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(fileInfo.fileFullPath)];
                                    case 3:
                                        fileBlob = _a.sent();
                                        _a.label = 4;
                                    case 4: return [2 /*return*/, {
                                            controlId: fileInfo.controlId,
                                            fileBlob: fileBlob,
                                            fileName: fileInfo.fileName,
                                            fileTypeInZip: fileInfo.fileTypeInZip
                                        }];
                                }
                            });
                        }); }, lodash_1.default.compact(fileInfos), 50)];
                case 4:
                    blobs = _a.sent();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(lodash_1.default.keys(contents), function (controlId) { return __awaiter(_this, void 0, void 0, function () {
                            var objList, archiveFilePath;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        objList = lodash_1.default.filter(blobs, { controlId: controlId });
                                        archiveFilePath = "".concat(archiveBasePath, "/").concat(name, "/").concat(controlId, ".zip");
                                        return [4 /*yield*/, (0, StorageManager_1.uploadZipFromBlob)(archiveFilePath, objList)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function convertEvaluationToJson(type, name) {
    return __awaiter(this, void 0, void 0, function () {
        var collectionName, result, _a, _b, items, resultJson, resultBlob, fileName, filePath;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    collectionName = (0, Evaluation_1.getKoEvaluation)(type);
                    _c = {};
                    _a = collectionName;
                    _d = {};
                    _b = name;
                    _e = {};
                    return [4 /*yield*/, (0, EvaluationLoader_1.getBase)(type, name)];
                case 1:
                    result = (_c[_a] = (_d[_b] = (_e.개요 = _f.sent(),
                        _e[EvaluationUtils_1.STATE_DOC_NAME] = {},
                        _e[EvaluationUtils_1.CONTENT_DOC_NAME] = {},
                        _e),
                        _d),
                        _c);
                    return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationItems)(type, name)];
                case 2:
                    items = _f.sent();
                    lodash_1.default.forEach(items, function (item, controlId) {
                        result[collectionName][name][EvaluationUtils_1.CONTENT_DOC_NAME][controlId] = item.content;
                        result[collectionName][name][EvaluationUtils_1.STATE_DOC_NAME][controlId] = item.state;
                    });
                    resultJson = JSON.stringify(result);
                    resultBlob = new Blob([resultJson], { type: 'text/json' });
                    fileName = "".concat(name, ".json");
                    filePath = "Archive/".concat(collectionName, "/").concat(name, "/").concat(fileName);
                    return [4 /*yield*/, (0, StorageManager_1.uploadFile)(filePath, resultBlob)];
                case 3:
                    _f.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function close(type, name) {
    return __awaiter(this, void 0, void 0, function () {
        var editable, stateDataAll, count, currentTime, collectionName, docRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, EvaluationLoader_1.checkEditable)(type, name)];
                case 1:
                    editable = _a.sent();
                    if (!editable) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00(".concat(name, ")\uB294 \uC774\uBBF8 \uB9C8\uAC10\uB41C \uD3C9\uAC00\uC774\uAE30 \uB584\uBB38\uC5D0 \uC218\uC815/\uC0AD\uC81C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.")))];
                    }
                    return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationStates)(type, name)];
                case 2:
                    stateDataAll = _a.sent();
                    count = {
                        state_5: 0,
                        resultState_2: 0,
                        resultState_3: 0,
                        weakState_2: 0,
                        weakState_3: 0,
                        weakState_4: 0,
                        weakState_5: 0
                    };
                    lodash_1.default.forEach(stateDataAll, function (stateData) {
                        var state = stateData.state;
                        if (state === Evaluation_1.ProgressState.Approved) {
                            count.state_5 += 1;
                        }
                        var resultState = stateData.resultState;
                        if (resultState === Evaluation_1.ResultState.Normal) {
                            count.resultState_2 += 1;
                        }
                        else if (resultState === Evaluation_1.ResultState.Defect) {
                            count.resultState_3 += 1;
                        }
                        var weakState = stateData.weakState;
                        if (weakState === Evaluation_1.OperationWeakState.Pending) {
                            count.weakState_2 += 1;
                        }
                        else if (weakState === Evaluation_1.OperationWeakState.Deficiency) {
                            count.weakState_3 += 1;
                        }
                        else if (weakState === Evaluation_1.OperationWeakState.SignificantDeficiency) {
                            count.weakState_4 += 1;
                        }
                        else if (weakState === Evaluation_1.OperationWeakState.MaterialWeakness) {
                            count.weakState_5 += 1;
                        }
                    });
                    if (count.state_5 !== count.resultState_2 + count.resultState_3) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00 \uB9C8\uAC10 \uC2DC \uC218\uB7C9 \uBB38\uC81C: \uC2B9\uC778\uC644\uB8CC \uAC1C\uC218 != \uD2B9\uC774\uC0AC\uD56D \uC5C6\uC74C \uAC1C\uC218 + \uC608\uC678\uC0AC\uD56D \uBC1C\uC0DD \uAC1C\uC218"))];
                    }
                    if (count.weakState_2 !== 0) {
                        return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00 \uB9C8\uAC10 \uC2DC \uC218\uB7C9 \uBB38\uC81C: \uBBF8\uBE44\uC810 \uD3C9\uAC00\uB300\uAE30 \uAC1C\uC218 != 0"))];
                    }
                    if (type === Evaluation_1.Type.Operation) {
                        if (count.resultState_3 !== count.weakState_3 + count.weakState_4 + count.weakState_5) {
                            return [2 /*return*/, Promise.reject(new Error("\uD3C9\uAC00 \uB9C8\uAC10 \uC2DC \uC218\uB7C9 \uBB38\uC81C: \uC6B4\uC601\uD3C9\uAC00: \uC608\uC678\uC0AC\uD56D \uBC1C\uC0DD \uAC1C\uC218 != \uB2E8\uC21C\uD55C \uBBF8\uBE44\uC810 \uAC1C\uC218  + \uC720\uC758\uD55C \uBBF8\uBE44\uC810 \uAC1C\uC218  + \uC911\uC694\uD55C \uCDE8\uC57D\uC810 \uAC1C\uC218"))];
                        }
                    }
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    collectionName = (0, Evaluation_1.getKoEvaluation)(type);
                    docRef = firebase.dbService.collection(collectionName).doc(name);
                    return [4 /*yield*/, docRef.update({
                            state: Evaluation_1.EvaluationState.Closed,
                            closeTime: currentTime
                        })];
                case 3:
                    _a.sent();
                    if (!(type === Evaluation_1.Type.Operation)) return [3 /*break*/, 6];
                    return [4 /*yield*/, archiveEvaluation(type, name)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, convertEvaluationToJson(type, name)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 6: return [4 /*yield*/, applyDesignEvaluationModificationToRCM(name)];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, archiveEvaluation(type, name)];
                case 8:
                    _a.sent();
                    return [4 /*yield*/, convertEvaluationToJson(type, name)];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.close = close;
//# sourceMappingURL=EvaluationArchiver.js.map